import { render, staticRenderFns } from "./PetDetail.vue?vue&type=template&id=cb20d2ba&scoped=true&"
import script from "./PetDetail.vue?vue&type=script&lang=js&"
export * from "./PetDetail.vue?vue&type=script&lang=js&"
import style0 from "./PetDetail.vue?vue&type=style&index=0&id=cb20d2ba&prod&lang=scss&scoped=true&"
import style1 from "./PetDetail.vue?vue&type=style&index=1&id=cb20d2ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb20d2ba",
  null
  
)

export default component.exports